module.exports = __webpack_public_path__ + "static/media/kms_indicator.ae30a624.svg";